import { gql } from '@apollo/client';

export const suspendCards = gql`
  mutation suspendCards($input: SuspendCardsInput!) {
    suspendCards(input: $input) {
      altId
      externalNumber
      cardStatus
      driver {
        altId
      }
    }
  }
`;
